import { render, staticRenderFns } from "./ImportQuestions.vue?vue&type=template&id=3948657d&"
import script from "./ImportQuestions.vue?vue&type=script&lang=js&"
export * from "./ImportQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports